import { Controller } from "@hotwired/stimulus";

/**
 * Stimulus controller for listening to Turbo Stream append events and dispatching a custom event.
 * Useful for triggering logic after Turbo Streams append new content to the DOM.
 *
 * @class TurboAppendController
 * @extends Controller
 */
export default class extends Controller {
  /**
   * Called when the controller is connected to the DOM.
   * Sets up the Turbo Stream event listener.
   */
  connect() {
    // For debugging: confirm controller is active
    console.log("Connected to the turbo append channel.");
    this.handleStreamRenderBound = this.handleStreamRender.bind(this);
    this.listenForTurboAppend();
    // Example: dispatch a custom event immediately if needed
    // const trigger = new CustomEvent("turbo-appended");
    // window.dispatchEvent(trigger);
  }

  /**
   * Adds a listener for Turbo Stream before-render events.
   * Uses a bound handler to ensure proper removal on disconnect.
   */
  listenForTurboAppend() {
    document.addEventListener("turbo:before-stream-render", this.handleStreamRenderBound);
  }

  /**
   * Handles Turbo Stream render events.
   * Dispatches a custom event only when the action is "append".
   * @param {Event} event
   */
  handleStreamRender(event) {
    const turboStreamElement = event.target;
    // Check if the action is "append"
    const action = turboStreamElement.getAttribute("action");
    if (action === "append") {
      // Only trigger this logic when action is append
      const trigger = new CustomEvent("turbo-appended");
      window.dispatchEvent(trigger);
      // Place any additional custom logic here if needed
    }
  }

  /**
   * Called when the controller is disconnected from the DOM.
   * Removes the Turbo Stream event listener to prevent memory leaks.
   */
  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.handleStreamRenderBound);
  }
}
